import { useNavigate } from "react-router-dom";
import { coverUri } from "../lib/api";
import { fmtClock } from "../lib/format";
import { usePlayer, songsQueue } from "../lib/player";
import { Icon } from "./icons";

const Round = ({ icon, label, onClick, big, testid, disabled }) => (
  <button className="icon-btn" aria-label={label} title={label} onClick={onClick} disabled={disabled} data-testid={testid}
    style={{ width: big ? 52 : 40, height: big ? 52 : 40, flexShrink: 0, ...(big ? { background: "var(--brand-primary)" } : { background: "var(--surface-2)" }) }}>
    <Icon name={icon} size={big ? 24 : 18} color={big ? "var(--on-brand)" : undefined} />
  </button>
);

/** Player card on the Home: the current track when something plays, otherwise quick starts. */
export function HomePlayer({ continueSongs = [], highlightSongs = [], user }) {
  const p = usePlayer();
  const navigate = useNavigate();
  if (p.item) {
    const { now, status } = p;
    const pct = status.d ? (status.t / status.d) * 100 : 0;
    return (
      <div className="card" style={{ padding: 16, display: "flex", flexDirection: "column", gap: 12, borderColor: "var(--brand-primary)" }} data-testid="home-player">
        <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
          <img className="cover" src={coverUri(now?.song?.cover_url || p.item.cover_url)} alt="" style={{ width: 72, height: 72, borderRadius: 10, flexShrink: 0 }} />
          <button onClick={() => navigate(p.context?.path || `/song/${p.item.song_id}`)} style={{ flex: 1, minWidth: 0, background: "none", border: "none", color: "inherit", textAlign: "left", cursor: "pointer", padding: 0 }} data-testid="home-player-open">
            <div className="t-kicker" style={{ color: "var(--brand-primary)" }}>{status.playing ? "A TOCAR" : "EM PAUSA"}{p.context?.label ? ` · ${p.context.label.toUpperCase()}` : ""}</div>
            <div style={{ fontFamily: "var(--f-medium)", fontSize: 18, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} data-testid="home-player-title">{now?.song?.title || p.item.title}</div>
            <div className="t-hint">{now?.part?.voice || "…"} · {fmtClock(status.t)} / {fmtClock(status.d)}</div>
            {p.nextItem ? <div className="t-hint" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>A seguir: {p.nextItem.title}</div> : null}
          </button>
        </div>
        <div className="mini-progress" style={{ position: "static", borderRadius: 4 }} onClick={(e) => { const r = e.currentTarget.getBoundingClientRect(); p.seek(((e.clientX - r.left) / r.width) * (status.d || 0)); }} data-testid="home-player-seek">
          <div style={{ width: `${pct}%` }} />
        </div>
        <div style={{ display: "flex", justifyContent: "center", gap: 14, alignItems: "center" }}>
          <Round icon="play-back" label="Anterior" onClick={p.prev} testid="home-player-prev" />
          <Round icon={status.playing ? "pause" : "play"} label={status.playing ? "Pausa" : "Reproduzir"} onClick={p.toggle} big testid="home-player-toggle" />
          <Round icon="play-forward" label="Seguinte" onClick={p.next} disabled={!p.nextItem} testid="home-player-next" />
        </div>
      </div>
    );
  }
  const starts = [
    { key: "continue", label: "Continuar a estudar", songs: continueSongs, icon: "play" },
    { key: "highlights", label: "Destaques", songs: highlightSongs, icon: "star" },
  ].filter((x) => x.songs.length);
  return (
    <div className="card" style={{ padding: 16, display: "flex", flexDirection: "column", gap: 12 }} data-testid="home-player-idle">
      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
        <span style={{ width: 48, height: 48, borderRadius: 999, background: "var(--brand-tertiary)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><Icon name="musical-notes" size={22} color="var(--brand-primary)" /></span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="t-kicker">LEITOR</div>
          <div style={{ fontFamily: "var(--f-medium)", fontSize: 16 }}>Ouvir na voz {user?.voice ? `de ${user.voice}` : "do seu naipe"}</div>
        </div>
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {starts.map((x) => (
          <button key={x.key} className="chip" onClick={() => p.playQueue(songsQueue(x.songs), 0, { key: `home:${x.key}`, label: x.label, path: "/" })} data-testid={`home-player-start-${x.key}`}>
            <Icon name={x.icon} size={14} /> {x.label.toUpperCase()} · {x.songs.length}
          </button>
        ))}
        <button className="chip" onClick={() => navigate("/listas")} data-testid="home-player-start-playlists"><Icon name="list" size={14} /> AS MINHAS LISTAS</button>
      </div>
    </div>
  );
}
